import React, { useEffect, useState } from "react";
import "../App.css";

// helper: جدا کردن pollCode و contactCode از کد ترکیبی
function parseCombinedCode(codeParam) {
  if (!codeParam) return { pollCode: null, contactCode: null };

  const lower = codeParam.toLowerCase();
  const idx = lower.indexOf("p");
  if (idx === -1) {
    return { pollCode: codeParam, contactCode: null };
  }

  const pollCode = codeParam.substring(0, idx + 1); // شامل حرف p
  const contactCode = codeParam.substring(idx + 1) || null;
  return { pollCode, contactCode };
}

function optionLabelsForAnswerType(answerType) {
  if (answerType === 1) {
    return [
      { value: 0, label: "خیر" },
      { value: 1, label: "بله" },
    ];
  } else {
    return [
      { value: 0, label: "عالی" },
      { value: 1, label: "خوب" },
      { value: 2, label: "متوسط" },
      { value: 3, label: "ضعیف" },
      { value: 4, label: "خیلی ضعیف" },
    ];
  }
}

export default function PollApp() {
  const [loading, setLoading] = useState(true);
  const [poll, setPoll] = useState(null);
  const [contact, setContact] = useState(null);
  const [error, setError] = useState(null);
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const rawCode = params.get("code");

  const apiBase = "https://api.mahanbs.com/api";

  useEffect(() => {
    if (!rawCode) {
      setError("لطفاً از طریق لینک اختصاصی نظرسنجی وارد شوید.");
      setLoading(false);
      return;
    }

    const fetchAllData = async () => {
      setLoading(true);

      try {
        const { pollCode, contactCode } = parseCombinedCode(rawCode);

        // 1. چک کردن اینکه آیا کاربر قبلاً شرکت کرده
        const checkUrl = `${apiBase}/Poll/checkSubmission?pollCode=${encodeURIComponent(
          pollCode,
        )}&contactCode=${encodeURIComponent(contactCode)}`;
        const checkRes = await fetch(checkUrl);

        if (checkRes.ok) {
          const checkData = await checkRes.json();
          if (checkData.hasSubmitted) {
            // نمایش پیغام خطا و توقف فرآیند
            setError("شما قبلاً در این نظرسنجی شرکت کرده‌اید.");
            setLoading(false);
            return;
          }
        }

        // 2. دریافت اطلاعات تماس
        const contactUrl = `${apiBase}/Contact/search?code=${encodeURIComponent(
          contactCode,
        )}`;
        const contactRes = await fetch(contactUrl);
        if (!contactRes.ok) throw new Error("خطا در واکشی اطلاعات کاربر.");
        const contactData = await contactRes.json();
        setContact(contactData);

        // 3. دریافت اطلاعات نظرسنجی
        const pollUrl = `${apiBase}/Poll/search?code=${encodeURIComponent(
          pollCode,
        )}`;
        const pollRes = await fetch(pollUrl);
        if (!pollRes.ok) throw new Error("خطا در فراخوانی Poll API.");
        const pollData = await pollRes.json();

        if (pollData.isExpired) {
          setError("مهلت این نظرسنجی به پایان رسیده و قابل شرکت نیست.");
        } else {
          setPoll(pollData);
        }
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [rawCode, apiBase]);

  if (loading) return <div className="mp-loading">در حال بارگذاری...</div>;

  // شرط جدید برای نمایش خطا
  if (error) {
    return (
      <div className="zht-poll-root">
        <div className="mp-error-container">
          <div className="mp-error-message">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!poll)
    return (
      <div className="zht-poll-root">
        <div className="mp-error">نظرسنجی پیدا نشد.</div>
      </div>
    );

  const questions = poll.questions || [];
  const current = questions[index];

  const setAnswer = (questionGuid, value) => {
    setAnswers((prev) => ({ ...prev, [questionGuid]: value }));
  };

  // آپدیت شده: بررسی پاسخ داده شدن همه سوالات با در نظر گرفتن نوع متنی
  const allAnswered =
    questions.length > 0 &&
    questions.every((q) => {
      const val = answers[q.questionGuid];
      return (
        answers.hasOwnProperty(q.questionGuid) &&
        (q.answerType !== 3 || (typeof val === "string" && val.trim() !== ""))
      );
    });

  function prev() {
    setIndex((i) => Math.max(0, i - 1));
  }

  function next() {
    const val = answers[current.questionGuid];
    const hasValidAnswer =
      answers.hasOwnProperty(current.questionGuid) &&
      (current.answerType !== 3 || (typeof val === "string" && val.trim() !== ""));

    if (hasValidAnswer) {
      setIndex((i) => Math.min(questions.length - 1, i + 1));
    } else {
      alert("لطفاً به سوال فعلی پاسخ دهید.");
    }
  }

  function renderOptions(q) {
    if (q.answerType === 3) {
      return (
        <div className="mp-options-text">
          <textarea
            className="mp-textarea"
            rows="4"
            placeholder="پاسخ خود را اینجا بنویسید..."
            value={answers[q.questionGuid] || ""}
            onChange={(e) => setAnswer(q.questionGuid, e.target.value)}
          ></textarea>
        </div>
      );
    }

    const opts = optionLabelsForAnswerType(q.answerType);
    return (
      <div className="mp-options">
        {opts.map((opt) => (
          <label key={opt.value} className="mp-option">
            <input
              type="radio"
              name={q.questionGuid}
              checked={answers[q.questionGuid] === opt.value}
              onChange={() => setAnswer(q.questionGuid, opt.value)}
            />
            <span className="mp-option-label">{opt.label}</span>
          </label>
        ))}
      </div>
    );
  }

  async function handleSubmit() {
    if (!allAnswered) {
      alert("لطفاً به همه سوالات پاسخ دهید.");
      return;
    }

    const payload = {
      pollGuid: poll.pollGuid,
      pollCode: poll.code || poll.pollCode,
      courseGuid: poll.courseGuid,
      lessonGuid: poll.lessonGuid,
      contactCode: parseCombinedCode(rawCode).contactCode || null,
      answers: questions.map((q) => ({
        name: q.name,
        questionGuid: q.questionGuid,
        answerType: q.answerType,
        value: answers[q.questionGuid],
      })),
    };

    setSubmitting(true);
    try {
      const res = await fetch(`${apiBase}/Poll/submit`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const txt = await res.text();
        throw new Error("خطا در ارسال: " + txt);
      }

      setSubmitting(false);
      setIsSubmitted(true);
    } catch (err) {
      console.error(err);
      setSubmitting(false);
      alert("خطا در ارسال پاسخ‌ها: " + err.message);
    }
  }

  return (
    <div className="zht-poll-root">
      {isSubmitted ? (
        <div className="mp-success-message-container">
          <div className="mp-success-message">
            <h3 className="mp-modal-header">ارزیابی شما با موفقیت ثبت شد.</h3>
            {contact && (
              <p>
                از شما مدیر گرامی{" "}
                <span className="mp-info-highlight">
                  {contact.firstName} {contact.lastName}
                </span>
                ، بابت شرکت در نظرسنجی و ارائه بازخوردهای ارزشمندتان سپاسگزاریم.
              </p>
            )}
            <p>
              با تکمیل این ارزیابی، ۲۰ امتیاز به باشگاه مدیران ماهان شما اضافه
              شد.
            </p>
          </div>
        </div>
      ) : (
        <div className="mp-container">
          <div className="mp-header">
            {contact && (
              <div className="mp-welcome">
                <h3 className="mp-welcome-title">
                  مدیر گرامی {contact.firstName} {contact.lastName} عزیز و
                  هم‌راه ماهانی
                </h3>
                <p>
                  حضور و مشارکت شما همواره سرمایه اصلی ما در مسیر توسعه دانش و
                  مهارت‌های مدیریتی بوده است.
                  <br />
                  با تکمیل این ارزیابی، ضمن دریافت ۲۰ امتیاز در باشگاه مدیران
                  ماهان، ما را در بهبود محتوای آموزشی و ارتقای تجربه یادگیری
                  یاری خواهید کرد.
                  <br />
                  دقت‌نظر و بازخورد صریح شما، راهنمای ما برای ارائه آموزش‌هایی
                  کارآمدتر و متناسب با نیاز مدیران پیشرو خواهد بود.
                </p>
              </div>
            )}
            <div className="mp-poll-info">
              ارزیابی درس{" "}
              <span className="mp-info-highlight">{poll.lesson}</span> از دوره{" "}
              <span className="mp-info-highlight">{poll.course}</span>،با تدریس{" "}
              <span className="mp-info-highlight">{poll.teacher}</span>.
            </div>
          </div>
          <div className="mp-body">
            <div className="mp-progress">
              {index + 1} / {questions.length}
            </div>
            {current ? (
              <div className="mp-question-block">
                <div className="mp-question-text">
                  {current.number}. {current.name}
                </div>
                {renderOptions(current)}
              </div>
            ) : (
              <div>سؤالی وجود ندارد.</div>
            )}
            <div className="mp-controls">
              <button onClick={prev} disabled={index === 0}>
                قبل
              </button>
              {index < questions.length - 1 ? (
                <button onClick={next}>بعد</button>
              ) : (
                <button
                  onClick={handleSubmit}
                  disabled={!allAnswered || submitting}
                >
                  {submitting ? "در حال ارسال..." : "ثبت نهایی"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}